import { Action } from 'types/redux'
import { handleAPI, API_VERSION_TWO } from 'utils/apiUtils'
import * as actions from './actions'

type TParams = {
  link_token: string
  link_type: string
}

export const showValidateToken = (link_token: string): Action => {
  const url = `/${API_VERSION_TWO}/sessions/validate_link`

  return {
    type: actions.SESSIONS_VALIDATE_LINK_SHOW,
    payload: handleAPI(url, { link_token }, 'GET'),
  }
}

export const requestNewLink = (params: TParams): Action => {
  const url = `/${API_VERSION_TWO}/sessions/request_new_link`

  return {
    type: actions.SESSIONS_REQUEST_NEW_LINK_POT,
    payload: handleAPI(url, params, 'PUT'),
  }
}

export type TChangePassword = {
  login: string // username
  old_password: string
  password: string
  password_confirmation: string
}
export const requestChangePassword = (data: TChangePassword): Action => {
  const url = `/${API_VERSION_TWO}/passwords/change_password`

  return {
    type: actions.REQUEST_CHANGE_PASSWORD,
    payload: handleAPI(url, {}, 'POST', data),
  }
}
